<mat-dialog-content style="text-align: center"
                    class="dialogDefaultHeight100 flex flex-vertical-center">
  <h5 class="flex flex-horizontal-center"> {{title}}</h5>
  <p *ngFor="let text of texts" class="flex flex-horizontal-center"> {{text}}</p>
  <button mat-button mat-stroked-button mat-dialog-close>{{'HOME.btn.close'|translate}} </button>
</mat-dialog-content>
